import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from "dayjs";
import Calendar from '../calendar/Calendar.js';

import ModalLoad from '../modal/ModalLoad.js';
import ModalPopupMessage from '../modal/ModalPopupMessage.js';

function HistoricalDataRawDataTable(props) {
    const [reportsite, setReportsite] = useState('-');

    const [data_uioption, setData_uioption] = useState({
        device_selector: [],
    });
    const [filter_prepare, setFilter_prepare] = useState({
        table: 'Environment',
        device_id: 'Environment',
        device_name: 'env',
        pvstring_support: 0,
        validate: 'all'
    });
    const [csv_data, setCsv_data] = useState({
        table_name: '',
        table_data: [],
        device_id: '',
        device_name: '',
        filename: '',
        count_good: 0
    })

    useEffect(() => {
        return () => {
            setString_tag_list([])
            setTag_list_selected([])
            setTag_list([])
        };
    }, []);

    useEffect(() => {
        if (reportsite !== "-") {
            if (props.permitdata.view_mode === "center") {
                api_getmeu()
            }
        }
    }, [reportsite, props.permitdata]);

    useEffect(() => {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.sitescope_arr !== null && props.permitdata.sitescope_arr !== undefined) {
                setReportsite(props.permitdata.sitescope_arr[0].sitecode_txt)
            }
        }
    }, [props.permitdata]);

    const [tag_list, setTag_list] = useState([
        { table: "Environment", tagname: "total_irr_avg", display: "IRR. AVG.", value: false, unit: "W/m2" },
        { table: "Environment", tagname: "total_irr1", display: "IRR1. Raw", value: false, unit: "W/m2" },
        { table: "Environment", tagname: "daily_irr1_mj", display: "IRR1. Daily (MJ)", value: false, unit: "MJ/m2" },
        { table: "Environment", tagname: "daily_irr1_kwh", display: "IRR1. Daily (kWh)", value: false, unit: "kWh/m2" },
        { table: "Environment", tagname: "total_irr1_sample", display: "IRR1. Sample30Sec", value: false, unit: "W/m2" },
        { table: "Environment", tagname: "total_irr2", display: "IRR2. Raw", value: false, unit: "W/m2", check: "has_irr2" },
        { table: "Environment", tagname: "daily_irr2_mj", display: "IRR2. Daily (MJ)", value: false, unit: "MJ/m2", check: "has_irr2" },
        { table: "Environment", tagname: "daily_irr2_kwh", display: "IRR2. Daily (kWh)", value: false, unit: "kWh/m2", check: "has_irr2" },
        { table: "Environment", tagname: "total_irr2_sample", display: "IRR2. Sample30Sec", value: false, unit: "W/m2", check: "has_irr2" },
        { table: "Environment", tagname: "amb_temp", display: "Ambient Temperature", value: false, unit: "°C" },
        { table: "Environment", tagname: "pv_temp", display: "PV. Temperature", value: false, unit: "°C" },
        { table: "Environment", tagname: "tray_temp", display: "Tray Temperature", value: false, unit: "°C" },
        { table: "Environment", tagname: "rh", display: "Relative Humidity", value: false, unit: "%RH" },
        { table: "Environment", tagname: "wind_speed", display: "Wind Speed", value: false, unit: "m/sec.", check: "has_windspeed" },
        { table: "Environment", tagname: "wind_direct", display: "Wind Direction", value: false, unit: "°", check: "has_windspeed" },
        { table: "Environment", tagname: "water_level", display: "Water Level", value: false, unit: "m.", check: "has_waterlevel" },
        { table: "Environment", tagname: "conn", display: "Connection", value: false, ops: 0, seq: true },
        { table: "Environment", tagname: "conn_irr1", display: "Conn.IRR1", value: false, ops: 1, seq: true },
        { table: "Environment", tagname: "conn_irr2", display: "Conn.IRR2", value: false, check: "has_irr2", ops: 1, seq: true },
        { table: "Environment", tagname: "conn_amb", display: "Conn.AmbientRH", value: false, ops: 1, seq: true },
        { table: "Environment", tagname: "conn_pv", display: "Conn.PVTemp", value: false, ops: 1, seq: true },
        { table: "Environment", tagname: "conn_tray", display: "Conn.TrayTemp", value: false, ops: 1, seq: true },
        { table: "Environment", tagname: "conn_wind", display: "Conn.Wind", value: false, check: "has_windspeed", ops: 1, seq: true },
        { table: "Environment", tagname: "conn_level", display: "Conn.Level", value: false, check: "has_waterlevel", ops: 1, seq: true },

        { table: "Grid Meter", tagname: "a_i", display: "I-A", value: false, unit: "A" },
        { table: "Grid Meter", tagname: "b_i", display: "I-B", value: false, unit: "A" },
        { table: "Grid Meter", tagname: "c_i", display: "I-C", value: false, unit: "A" },
        { table: "Grid Meter", tagname: "a_u", display: "V-A", value: false, unit: "V" },
        { table: "Grid Meter", tagname: "b_u", display: "V-B", value: false, unit: "V" },
        { table: "Grid Meter", tagname: "c_u", display: "V-C", value: false, unit: "V" },
        { table: "Grid Meter", tagname: "ab_u", display: "V-AB", value: false, unit: "V" },
        { table: "Grid Meter", tagname: "bc_u", display: "V-BC", value: false, unit: "V" },
        { table: "Grid Meter", tagname: "ca_u", display: "V-CA", value: false, unit: "V" },
        { table: "Grid Meter", tagname: "pf", display: "Power Factor", value: false, unit: "" },
        { table: "Grid Meter", tagname: "apparent_power", display: "Apparent Power", value: false, unit: "kVA" },
        { table: "Grid Meter", tagname: "reactive_power", display: "Reactive Power", value: false, unit: "kVAr" },
        { table: "Grid Meter", tagname: "active_power", display: "Active Power", value: false, unit: "kW" },
        { table: "Grid Meter", tagname: "active_power_a", display: "Active Power-A", value: false, unit: "kW" },
        { table: "Grid Meter", tagname: "active_power_b", display: "Active Power-B", value: false, unit: "kW" },
        { table: "Grid Meter", tagname: "active_power_c", display: "Active Power-C", value: false, unit: "kW" },
        { table: "Grid Meter", tagname: "ex_energy_active", display: "Energy Active Total Export", value: false, unit: "kWh" },
        { table: "Grid Meter", tagname: "ex_energy_reactive", display: "Energy Reactive Total Export", value: false, unit: "kVArh" },
        { table: "Grid Meter", tagname: "im_energy_active", display: "Energy Active Total Import", value: false, unit: "kWh" },
        { table: "Grid Meter", tagname: "im_energy_reactive", display: "Energy Reactive Total Import", value: false, unit: "kVArh" },
        { table: "Grid Meter", tagname: "conn", display: "Connection", value: false },

        { table: "Solar Meter", tagname: "a_i", display: "I-A", value: false, unit: "A" },
        { table: "Solar Meter", tagname: "b_i", display: "I-B", value: false, unit: "A" },
        { table: "Solar Meter", tagname: "c_i", display: "I-C", value: false, unit: "A" },
        { table: "Solar Meter", tagname: "a_u", display: "V-A", value: false, unit: "V" },
        { table: "Solar Meter", tagname: "b_u", display: "V-B", value: false, unit: "V" },
        { table: "Solar Meter", tagname: "c_u", display: "V-C", value: false, unit: "V" },
        { table: "Solar Meter", tagname: "Angle_a", display: "Angle-A", value: false, unit: "°" },
        { table: "Solar Meter", tagname: "Angle_b", display: "Angle-B", value: false, unit: "°" },
        { table: "Solar Meter", tagname: "Angle_c", display: "Angle-C", value: false, unit: "°" },
        { table: "Solar Meter", tagname: "freq", display: "Frequency", value: false, unit: "Hz" },
        { table: "Solar Meter", tagname: "pf", display: "Power Factor", value: false, unit: "" },
        { table: "Solar Meter", tagname: "active_power", display: "Active Power", value: false, unit: "kW" },
        { table: "Solar Meter", tagname: "active_power_a", display: "Active Power-A", value: false, unit: "kW" },
        { table: "Solar Meter", tagname: "active_power_b", display: "Active Power-B", value: false, unit: "kW" },
        { table: "Solar Meter", tagname: "active_power_c", display: "Active Power-C", value: false, unit: "kW" },
        { table: "Solar Meter", tagname: "reactive_power", display: "Reactive Power", value: false, unit: "kVAr" },
        { table: "Solar Meter", tagname: "ex_energy_active", display: "Energy Active Total Export", value: false, unit: "kWh" },
        { table: "Solar Meter", tagname: "ex_energy_reactive", display: "Energy Reactive Total Export", value: false, unit: "kVArh" },
        { table: "Solar Meter", tagname: "im_energy_active", display: "Energy Active Total Import", value: false, unit: "kWh" },
        { table: "Solar Meter", tagname: "im_energy_reactive", display: "Energy Reactive Total Import", value: false, unit: "kVArh" },
        { table: "Solar Meter", tagname: "conn", display: "Connection", value: false },

        { table: "Inverter", tagname: "a_i", display: "I-A", value: false, unit: "A" },
        { table: "Inverter", tagname: "b_i", display: "I-B", value: false, unit: "A" },
        { table: "Inverter", tagname: "c_i", display: "I-C", value: false, unit: "A" },
        { table: "Inverter", tagname: "a_u", display: "V-A", value: false, unit: "V" },
        { table: "Inverter", tagname: "b_u", display: "V-B", value: false, unit: "V" },
        { table: "Inverter", tagname: "c_u", display: "V-C", value: false, unit: "V" },
        { table: "Inverter", tagname: "ab_u", display: "V-AB", value: false, unit: "V" },
        { table: "Inverter", tagname: "bc_u", display: "V-BC", value: false, unit: "V" },
        { table: "Inverter", tagname: "ca_u", display: "V-CA", value: false, unit: "V" },
        { table: "Inverter", tagname: "freq", display: "Frequency", value: false, unit: "Hz" },
        { table: "Inverter", tagname: "pf", display: "Power Factor", value: false, unit: "" },
        { table: "Inverter", tagname: "active_power", display: "Active Power", value: false, unit: "kW" },
        { table: "Inverter", tagname: "reactive_power", display: "Reactive Power", value: false, unit: "kVAr" },
        { table: "Inverter", tagname: "mppt_power", display: "Mppt Power", value: false, unit: "kW" },
        { table: "Inverter", tagname: "mppt_1", display: "Mppt-1 Energy", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "mppt_2", display: "Mppt-2 Energy", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "mppt_3", display: "Mppt-3 Energy", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "mppt_4", display: "Mppt-4 Energy", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "mppt_5", display: "Mppt-5 Energy", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "mppt_6", display: "Mppt-6 Energy", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "mppt_7", display: "Mppt-7 Energy", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "mppt_8", display: "Mppt-8 Energy", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "mppt_9", display: "Mppt-9 Energy", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "mppt_10", display: "Mppt-10 Energy", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "mppt_total", display: "Mppt Energy Total", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "inv_state", display: "Inverter State", value: false, unit: "" },
        { table: "Inverter", tagname: "eff", display: "Efficiency", value: false, unit: "%" },
        { table: "Inverter", tagname: "temp", display: "Temperature", value: false, unit: "°C" },
        { table: "Inverter", tagname: "day_cap", display: "Energy Day", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "total_cap", display: "Energy Total", value: false, unit: "kWh" },
        { table: "Inverter", tagname: "conn", display: "Connection", value: false },

    ])
    const [string_tag_list, setString_tag_list] = useState([])
    const [tag_list_selected, setTag_list_selected] = useState([])
    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const onCalendaraChange = (date, dateString) => {
        setReportdate_dt(date)
    };

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        var temp_tag = []
        for (var i = 0; i < 28; i++) {
            var channel = (i + 1)
            temp_tag.push({ table: 'Inverter', tagname: 'pv_' + channel + '_i', display: 'PV' + channel + '_I', value: false, unit: 'A', index: i, channel: channel })
            temp_tag.push({ table: 'Inverter', tagname: 'pv_' + channel + '_u', display: 'PV' + channel + '_V', value: false, unit: 'V', index: i, channel: channel })
            temp_tag.push({ table: 'Inverter', tagname: 'pv_' + channel + '_p', display: 'PV' + channel + '_P', value: false, unit: 'kW', index: i, channel: channel })
        }
        setString_tag_list(temp_tag)
    }, []);

    useEffect(() => {
        if (props.data_uioption !== null && props.data_uioption !== undefined) {
            if (props.data_uioption.device_selector !== undefined && props.data_uioption.device_selector !== null) {
                setData_uioption(props.data_uioption)
            }
        }
    }, [props.data_uioption]);

    function disabledCalendar(current) {
        return current.isBefore(props.permitdata.cod_date, 'day') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'day')
    }

    async function api_query() {
        setCsv_data({
            table_name: filter_prepare.table,
            table_data: [],
            filename: '',
            count_good: 0,
            device_id: filter_prepare.device_id,
            device_name: filter_prepare.device_name
        })
        let temp_seleted = []
        let temp_seleted2 = []
        let tag_array = []

        temp_seleted = tag_list.filter(item => item.table === filter_prepare.table && item.value === true && check_tag(item.check))
        if (filter_prepare.table === "Inverter") {
            temp_seleted2 = string_tag_list.filter(item => item.table === filter_prepare.table && item.value === true && check_tag(item.check) && item.channel <= filter_prepare.pvstring_support)
            const newArray = temp_seleted.concat(temp_seleted2)
            setTag_list_selected(newArray)
        } else {
            setTag_list_selected(temp_seleted)
        }

        if (filter_prepare.table !== "" && filter_prepare.table !== "-") {
            if (temp_seleted.length > 0 || temp_seleted2.length > 0) {
                for (const element of temp_seleted) {
                    tag_array.push(filter_prepare.device_name + "." + element.tagname)
                }
                if (filter_prepare.table === "Inverter") {
                    for (const element of temp_seleted2) {
                        tag_array.push(filter_prepare.device_name + "." + element.tagname)
                    }
                }
                let dt = dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD")

                setmodal_load({ enable: true, message: "Query historical raw data table." })
                await sleep(500)

                const formData = new FormData();
                formData.append('post_url', "/proxy/center/api/center/historical/rawdata")
                formData.append('token', props.permitdata.token)

                formData.append('table', filter_prepare.table)
                formData.append('device_name', filter_prepare.device_name)
                formData.append('reportdate', dt)
                formData.append('taglist', tag_array.join("#"))
                formData.append('validate', filter_prepare.validate)
                if (props.permitdata.view_mode === "local") {
                    formData.append('sitecode', props.permitdata.sitecode)
                } else {
                    formData.append('sitecode', reportsite)
                }

                axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/historical/rawdata", formData, {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'multipart/form-data;',
                        "Authorization": "Bearer " + props.permitdata.token
                    },
                })
                    .then((response) => {
                        setmodal_load({ enable: false, message: "" })
                        if (response.data.status === 'OK') {
                            if (response.data.tabledata !== null) {
                                setCsv_data({
                                    ...csv_data,
                                    table_name: response.data.tablename,
                                    table_data: response.data.tabledata,
                                    filename: response.data.filename,
                                    count_good: response.data.count_good,
                                    device_name: response.data.device_name,
                                    device_id: filter_prepare.device_id
                                })
                            } else {
                                setModal_popup({
                                    modaltype: 'modal-warning',
                                    headers: 'Warning',
                                    message: "Data not found on your qury period!.",
                                    enable: true
                                })
                            }
                        }
                        else {
                            setModal_popup({
                                modaltype: 'modal-error',
                                headers: 'Error',
                                message: response.data.message,
                                enable: true
                            })
                        }
                    })
                    .catch((err) => {
                        setmodal_load({ enable: false, message: "" })
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: err.message,
                            enable: true
                        })
                    });
            } else {
                setModal_popup({
                    modaltype: 'modal-warning',
                    headers: 'Warning',
                    message: "Please select at least 1 tag.",
                    enable: true
                })
            }
        } else {
            setModal_popup({
                modaltype: 'modal-warning',
                headers: 'Warning',
                message: "Please select table.",
                enable: true
            })
        }
    }

    async function api_getmeu() {
        setmodal_load({ enable: true, message: "Loading tags list......" })
        await sleep(500)

        const formData = new FormData();
        formData.append('sitecode', reportsite)

        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/historical/rawmenu", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.taglist !== null) {
                        setData_uioption(response.data.uioption)
                        setTag_list(response.data.taglist)
                        if (response.data.stringlist !== null) {
                            setString_tag_list(response.data.stringlist)
                        }
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function export_csv() {
        if (csv_data.filename !== "") {
            let table_name = ""
            if (csv_data.table_name === "Environment") {
                table_name = "table-environment"
            } else if (csv_data.table_name === "Grid Meter") {
                table_name = "table-grid"
            } else if (csv_data.table_name === "Solar Meter") {
                table_name = "table-solar"
            } else if (csv_data.table_name === "Inverter") {
                table_name = "table-inverter"
            }

            const tableData = [];
            const rows = document.querySelectorAll("table." + table_name + " tr");
            for (const row of rows) {
                const rowData = [];
                for (const [index, column] of row.querySelectorAll("th, td").entries()) {
                    if (index < 90) {
                        var tdata = column.innerText.replaceAll(",", "")
                        rowData.push(tdata);
                    }
                }
                tableData.push(rowData.join(","));
            }

            let data = tableData.join("\n");
            const a = document.createElement("a");
            a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
            var fnamey = 'RawData_' + csv_data.device_id + "_" + csv_data.filename + '.csv'
            a.setAttribute("download", fnamey);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            setModal_popup({
                modaltype: 'modal-warning',
                headers: 'Warning',
                message: "No data to export!",
                enable: true
            })
        }
    }

    function tag_selectall(table) {
        const nextdata = tag_list.map(item => {
            if (((item.table === "Environment" && check_tag(item.check, item.ops, item.seq) === true) || item.table !== "Environment") && item.table === table) {
                return {
                    ...item,
                    value: true,
                };
            } else {
                return item;
            }
        });
        setTag_list(nextdata)
        if (table === "Inverter") {
            const nextdata = string_tag_list.map(item => {
                if (item.table === table) {
                    return {
                        ...item,
                        value: true,
                    };
                } else {
                    return {
                        ...item,
                        value: false,
                    };
                }
            });
            setString_tag_list(nextdata)
        }
    }

    function tag_reselall(table) {
        const nextdata = tag_list.map(item => {
            return {
                ...item,
                value: false,
            };
        });
        setTag_list(nextdata)
        if (table === "Inverter") {
            const nextdata = string_tag_list.map(item => {
                return {
                    ...item,
                    value: false,
                };
            });
            setString_tag_list(nextdata)
        }
    }

    function check_tag(check, ops, seq) {
        if ((check === undefined && seq === undefined) || props.permitdata.view_mode === "center") {
            return true
        }
        if (data_uioption.has_irr2 !== undefined && data_uioption.has_irr2 !== null) {
            if (seq !== undefined) {
                if (check !== undefined) {
                    if (data_uioption["sequence"] === ops && data_uioption[check] === true) {
                        return true
                    }
                } else {
                    if (data_uioption["sequence"] === ops) {
                        return true
                    }
                }
            } else {
                if (check !== undefined) {
                    if (data_uioption[check] === true) {
                        return true
                    }
                }
            }
        }
        return false
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    function getTableCalssname(table) {
        if (table === "Environment") {
            return "table-environment"
        } else if (table === "Grid Meter") {
            return "table-grid"
        } else if (table === "Solar Meter") {
            return "table-solar"
        } else if (table === "Inverter") {
            return "table-inverter"
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-table-search color-orange"></i> Raw Data Table</h4>
                                    <p className="mb-0">Query your solar data with raw table style</p>
                                </div>
                                {
                                    !props.iscenter ?
                                        <div>
                                            {BackCenter()}
                                        </div>
                                        : null
                                }
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                        {
                            props.iscenter ?
                                <div className="d-block">
                                    <label htmlFor="reportsite" className="form-label mb-0">Select Site</label>
                                    <select id="reportsite" name="reportsite" className="form-select font-sarabun" value={reportsite} onChange={(e) => {
                                        setReportsite(e.target.value)
                                    }} required>
                                        {
                                            props.permitdata !== null ?
                                                props.permitdata.sitescope_arr.map((data, index) => (
                                                    <option value={data.sitecode_txt} key={data.sitecode_txt}>{data.sitecode_txt} {data.sitename_th}</option>
                                                ))
                                                :
                                                null
                                        }
                                    </select>
                                </div>
                                : null
                        }
                        <div className="d-block " style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select Date</label>
                            <Calendar
                                allowClear={false}
                                className={"form-control"}
                                onChange={onCalendaraChange}
                                style={{
                                    fontFamily: "poppins",
                                    fontSize: "0.75rem",
                                    Color: "black",
                                    lineHeight: "1.5",
                                    cursor: "pointer",
                                }}
                                value={reportdate_dt}
                                disabledDate={disabledCalendar}
                            />
                        </div>
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="table" className="form-label mb-0">Select Device</label>
                            <select id="table" name="table" className="form-select" value={filter_prepare.device_name} onChange={(e) => {
                                const found = data_uioption.device_selector.find((element) => element.device_name_raw === e.target.value);
                                setFilter_prepare({
                                    ...filter_prepare,
                                    table: found.table,
                                    device_id: found.device_id,
                                    device_name: found.device_name_raw,
                                    pvstring_support: found.pvstring_support,
                                })
                            }} required>
                                {
                                    data_uioption.device_selector.map((device, index) => (
                                        device.device_id !== "All" && device.device_id !== "PLC" && device.device_id !== "Server" ?
                                            <option key={device.device_name_raw} value={device.device_name_raw}>{device.device_id}</option>
                                            :
                                            null
                                    ))
                                }
                            </select>
                        </div>
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="validate" className="form-label mb-0">Select Quality</label>
                            <select id="validate" name="validate" className="form-select" value={filter_prepare.validate} onChange={(e) => {
                                setFilter_prepare({
                                    ...filter_prepare,
                                    validate: e.target.value
                                })
                            }} required>
                                <option value="good">Found Data</option>
                                <option value="all">Include Blank</option>
                            </select>
                        </div>
                        <div className='d-flex'>
                            <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                                <button className="btn btn-info btn-sm me-5" onClick={() => { api_query() }}><i className="fas fa-search "></i> Query</button>
                            </div>
                            <div className="d-block align-self-end print-disable">
                                <div className="d-flex gap-1 mt-3 mt-lg-0" style={{ marginBottom: "3px" }}>
                                    <button className="btn btn-secondary btn-sm " onClick={() => { export_csv() }}><i className="fas fa-file-csv "></i> Export CSV</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex rawdata-result-box">
                        <div className="tags-box me-2">
                            <h6>Tags List Selector</h6>
                            <div className='d-flex gap-3 mb-2'>
                                <div className='d-block mouse-pointer' onClick={() => { tag_selectall(filter_prepare.table) }}>Select All</div>
                                <div className='d-block mouse-pointer' onClick={() => { tag_reselall(filter_prepare.table) }}>Deselect All</div>
                            </div>
                            <div className="d-block align-self-end print-disable scrollable" style={{ paddingBottom: "3px" }}>
                                {
                                    tag_list.map((data, index) => (
                                        data.table === filter_prepare.table ?
                                            (data.table === "Environment" && check_tag(data.check, data.ops, data.seq) === true) || data.table !== "Environment" ?
                                                <div className="form-check" key={data.table + "-" + data.tagname}>
                                                    <input id={data.table + "-" + data.tagname} name={data.table + "-" + data.tagname} className="form-check-input" type="checkbox" checked={data.value} onChange={(e) => {
                                                        const nextdata = tag_list.map(item => {
                                                            if (item.table === data.table && item.tagname === data.tagname) {
                                                                return {
                                                                    ...item,
                                                                    value: !item.value,
                                                                };
                                                            } else {
                                                                return item;
                                                            }
                                                        });
                                                        setTag_list(nextdata)
                                                    }} />
                                                    <label htmlFor={data.table + "-" + data.tagname} className="form-check-label">
                                                        {data.display}
                                                    </label>
                                                </div>
                                                :
                                                null
                                            :
                                            null
                                    ))
                                }
                                {
                                    string_tag_list.map((data, index) => (
                                        data.table === filter_prepare.table && filter_prepare.table === "Inverter" && data.channel <= filter_prepare.pvstring_support ?
                                            <div className="form-check" key={data.table + "-" + data.tagname}>
                                                <input id={data.table + "-" + data.tagname} name={data.table + "-" + data.tagname} className="form-check-input" type="checkbox" checked={data.value} onChange={(e) => {
                                                    const nextdata = string_tag_list.map(item => {
                                                        if (item.table === data.table && item.tagname === data.tagname) {
                                                            return {
                                                                ...item,
                                                                value: !item.value,
                                                            };
                                                        } else {
                                                            return item;
                                                        }
                                                    });
                                                    setString_tag_list(nextdata)
                                                }} />
                                                <label htmlFor={data.table + "-" + data.tagname} className="form-check-label">
                                                    {data.display}
                                                </label>
                                            </div>
                                            :
                                            null
                                    ))
                                }
                            </div>
                        </div>
                        <div className="table-box">
                            <h6>Query Result Table (Found {csv_data.count_good} Records)</h6>
                            <div className="table-wrapper">
                                {
                                    <table className={" font-sarabun " + getTableCalssname(csv_data.table_name)} >
                                        <thead>
                                            <tr>
                                                <th className='font-sarabun' style={{ minWidth: "155px !important" }}>Timestamp</th>
                                                {
                                                    tag_list_selected.map((data, index) => (
                                                        <th className='font-sarabun' key={"header1-" + data.table + "-" + data.tagname}>{data.display}</th>
                                                    ))
                                                }
                                            </tr>
                                            <tr>
                                                <th className='font-sarabun' style={{ minWidth: "155px !important" }}>Unit</th>
                                                {
                                                    tag_list_selected.map((data, index) => (
                                                        <th className='font-sarabun' key={"header2-" + data.table + "-" + data.tagname}>{data.unit}</th>
                                                    ))
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                csv_data.table_data.map((data, index) => (
                                                    <tr key={data.timestamp}>
                                                        <td className='font-sarabun' style={{ minWidth: "140px", maxWidth: "140px" }}>{data.timestamp}</td>
                                                        {
                                                            tag_list_selected.map((tag, index) => (
                                                                csv_data.table_name === tag.table ?
                                                                    tag.tagname !== "run_state" ?
                                                                        <td className='font-sarabun' key={"record-" + data.timestamp + "-" + tag.tagname}>{data[csv_data.device_name + "." + tag.tagname]}</td>
                                                                        :
                                                                        <td className='font-sarabun' key={"record-" + data.timestamp + "-" + tag.tagname}>{
                                                                            data.run_state === 0 ?
                                                                                <span className='font-sarabun color-red'>OFFLINE</span>
                                                                                : data.run_state === 1 ?
                                                                                    <span className='font-sarabun color-green'>ONLINE</span>
                                                                                    :
                                                                                    null
                                                                        }</td>
                                                                    :
                                                                    null
                                                            ))
                                                        }
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default HistoricalDataRawDataTable